import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Her route değişiminde en üste scroll yap
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname, location.key]);

  useEffect(() => {
    // Ekstra güvenlik için - state ile scroll sinyali gelirse
    if (location.state?.scrollToTop) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.state]);

  return null;
};

export default ScrollToTop;
